(function(){
    if (window.__tlcGiftNoteBound) return;
    window.__tlcGiftNoteBound = true;
    var timer;
    function persist(val){
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift note': val, 'Gift': val ? 'Yes' : '' } })
      }).catch(function(){});
    }
    function syncCount(el){
      var box = el.closest('.tlc-giftnote');
      var counter = box && box.querySelector('[data-tlc-gift-count]');
      if (counter) counter.textContent = el.value.length;
    }
    document.addEventListener('input', function(e){
      var el = e.target.closest('[data-tlc-gift-note]');
      if (!el) return;
      syncCount(el);
      clearTimeout(timer);
      var v = el.value;
      timer = setTimeout(function(){ persist(v); }, 500);
    });
    function initCounts(){
      document.querySelectorAll('[data-tlc-gift-note]').forEach(syncCount);
    }
    if (document.readyState !== 'loading') initCounts();
    else document.addEventListener('DOMContentLoaded', initCounts);
  })();
